/* ── LEXI Eyewear — Shared JS ── */

/* ── Product Catalog ── */
const CATALOG = {
  traveler: { id:'traveler', name:'TRAVELER', price:'€209,00', cat:'sun', limited:false, img:'images/prod-1.jpg', wear:'images/tl-1.jpg', swatch:'radial-gradient(circle at 35% 30%,#c98a4b,#7a4a1e)', color:'Honey Tortoise', tagline:'Looking sharp in Traveler.', desc:'A bold double-bridge aviator cut from honey tortoise Italian acetate, finished with ZEISS® amber gradient sun lenses for all-day glare control.', material:'Italian tortoise acetate', lens:'ZEISS® Amber Gradient', fit:'Medium – Wide' },
  topline: { id:'topline', name:'TOPLINE', price:'€225,00', cat:'sun', limited:false, img:'images/prod-2.jpg', wear:'images/tl-3.jpg', swatch:'radial-gradient(circle at 35% 30%,#f2d38f,#c79a3c)', color:'Brushed Gold', tagline:'The refined metal round.', desc:'A slim brushed-gold metal round with a signature top bar and deep green ZEISS® lenses. Lightweight, precise, timeless.', material:'Brushed gold metal', lens:'ZEISS® Green G-15', fit:'Narrow – Medium' },
  amber: { id:'amber', name:'AMBER X ELIAS MARLOWE', price:'€219,00', cat:'sun', limited:true, img:'images/prod-3.jpg', wear:'images/prod-3-hover.jpg', swatch:'#141414', color:'Matte Black', tagline:'A collab, sculpted by hand.', desc:'The Amber, reimagined with designer and stylist Elias Marlowe. A sculpted black acetate hexagon with smoke ZEISS® lenses — a numbered limited edition.', material:'Sculpted black acetate', lens:'ZEISS® Smoke', fit:'Medium' },
  apex: { id:'apex', name:'APEX', price:'€199,00', cat:'optical', limited:false, img:'images/prod-4.jpg', wear:'images/tl-4.jpg', swatch:'radial-gradient(circle at 35% 30%,#cfcfcf,#8f8f8f)', color:'Smoke Crystal', tagline:'Clean lines, cool blue.', desc:'A clean squared frame in translucent smoke crystal with a cool blue gradient. Equally at home as sun or optical.', material:'Translucent acetate', lens:'Blue Gradient', fit:'Medium' }
};
const PRODUCT_ORDER = ['traveler','topline','amber','apex'];

/* ── Cart ── */
const CART_KEY = 'dm-cart';
function readCart() { try { return JSON.parse(localStorage.getItem(CART_KEY)) || []; } catch(e) { return []; } }
function writeCart(c) { localStorage.setItem(CART_KEY, JSON.stringify(c)); }
function parsePrice(s) { return parseFloat(String(s).replace(/[^0-9,]/g,'').replace(',','.')) || 0; }
function fmt(n) { return '€' + n.toFixed(2).replace('.',','); }

function updateCart() {
  const c = readCart();
  const n = c.reduce((a,i) => a + (i.qty||1), 0);
  const badge = document.getElementById('dm-cart-count');
  if (badge) { badge.textContent = n; badge.style.display = n > 0 ? 'flex' : 'none'; }
  const nEl = document.getElementById('dm-cart-n');
  if (nEl) nEl.textContent = n;
  const items = document.getElementById('dm-cart-items');
  if (items) {
    if (!c.length) {
      items.innerHTML = '<div style="padding:64px 0;text-align:center;color:#9a9a9a;font-size:14px">Your cart is empty.</div>';
    } else {
      items.innerHTML = c.map((it, idx) =>
        '<div style="display:flex;gap:16px;align-items:center;padding:20px 0;border-bottom:1px solid rgba(0,0,0,.08)">' +
        (it.img ? '<div style="width:64px;height:64px;background:#f0eeea;flex:none;overflow:hidden;border-radius:6px"><img src="' + it.img + '" style="width:100%;height:100%;object-fit:contain"></div>' : '') +
        '<div style="flex:1;min-width:0"><div style="font-size:12px;letter-spacing:.08em;font-weight:600">' + it.name + '</div><div style="font-size:12px;color:#9a9a9a;margin-top:5px">' + it.price + '</div></div>' +
        '<button data-idx="' + idx + '" class="dm-remove" style="background:none;border:none;color:#9a9a9a;cursor:pointer;font-size:12px;text-decoration:underline">Remove</button>' +
        '</div>'
      ).join('');
      items.querySelectorAll('.dm-remove').forEach(b => {
        b.addEventListener('click', () => {
          const i = +b.getAttribute('data-idx');
          const cc = readCart(); cc.splice(i,1); writeCart(cc); updateCart();
        });
      });
    }
  }
  const tot = document.getElementById('dm-cart-total');
  if (tot) tot.textContent = fmt(c.reduce((a,i) => a + parsePrice(i.price)*(i.qty||1), 0));
}

function addToCart(name, price, img) {
  const c = readCart();
  c.push({ name, price, img, qty:1 });
  writeCart(c);
  updateCart();
  openCart();
}

/* ── Overlays ── */
function showScrim(on) {
  const s = document.getElementById('dm-scrim');
  if (s) { s.style.opacity = on ? '1' : '0'; s.style.pointerEvents = on ? 'auto' : 'none'; }
}

function closeAll() {
  showScrim(false);
  const se = document.getElementById('dm-search'); if (se) se.style.transform = 'translateY(-100%)';
  const cd = document.getElementById('dm-cart-drawer'); if (cd) cd.style.transform = 'translateX(105%)';
  const ac = document.getElementById('dm-account'); if (ac) { ac.style.opacity = '0'; ac.style.pointerEvents = 'none'; ac.style.transform = 'translate(-50%,-46%)'; }
  const cm = document.getElementById('dm-cur-menu'); if (cm) cm.style.display = 'none';
  const mn = document.getElementById('dm-menu'); if (mn) mn.style.transform = 'translateX(-100%)';
}

function openSearch() {
  closeAll(); showScrim(true);
  const se = document.getElementById('dm-search'); if (se) se.style.transform = 'translateY(0)';
  setTimeout(() => { const i = document.getElementById('dm-search-input'); if (i) i.focus(); }, 320);
}

function openCart() {
  closeAll(); updateCart(); showScrim(true);
  const cd = document.getElementById('dm-cart-drawer'); if (cd) cd.style.transform = 'translateX(0)';
}

function openAccount() {
  closeAll(); showScrim(true);
  const ac = document.getElementById('dm-account');
  if (ac) { ac.style.opacity = '1'; ac.style.pointerEvents = 'auto'; ac.style.transform = 'translate(-50%,-50%)'; }
}

function openMenu() {
  closeAll(); showScrim(true);
  const m = document.getElementById('dm-menu'); if (m) m.style.transform = 'translateX(0)';
}

function toggleCurrency() {
  const cm = document.getElementById('dm-cur-menu');
  if (cm) cm.style.display = cm.style.display === 'block' ? 'none' : 'block';
}

function pickCurrency(el) {
  const v = el.getAttribute('data-cur');
  const cur = document.getElementById('dm-cur');
  if (cur) cur.textContent = v;
  const cm = document.getElementById('dm-cur-menu'); if (cm) cm.style.display = 'none';
}

function checkout() {
  closeAll();
  window.location.href = 'checkout.html';
}

/* ── Card hover ── */
function cardEnter(card) {
  const z = card.querySelector('[data-zoom]');
  const sw = card.querySelector('[data-swap]');
  const h = card.querySelector('[data-hover]');
  if (z) z.style.transform = 'scale(1.05)';
  if (sw) sw.style.opacity = '1';
  if (h) { h.style.opacity = '1'; h.style.transform = 'translateY(0)'; h.style.pointerEvents = 'auto'; }
}

function cardLeave(card) {
  const z = card.querySelector('[data-zoom]');
  const sw = card.querySelector('[data-swap]');
  const h = card.querySelector('[data-hover]');
  if (z) z.style.transform = 'none';
  if (sw) sw.style.opacity = '0';
  if (h) { h.style.opacity = '0'; h.style.transform = 'translateY(10px)'; h.style.pointerEvents = 'none'; }
}

/* ── Init on every page ── */
document.addEventListener('DOMContentLoaded', () => {
  updateCart();

  // Close currency menu on outside click
  document.addEventListener('click', (ev) => {
    const menu = document.getElementById('dm-cur-menu');
    if (menu && menu.style.display === 'block' && !ev.target.closest('#dm-cur-menu') && !ev.target.closest('.cur-toggle')) {
      menu.style.display = 'none';
    }
  });

  // Wire up quick-add buttons
  document.querySelectorAll('.quick-add-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault(); e.stopPropagation();
      addToCart(btn.dataset.name, btn.dataset.price, btn.dataset.img);
    });
  });

  // Wire up card hover
  document.querySelectorAll('.product-card').forEach(card => {
    card.addEventListener('mouseenter', () => cardEnter(card));
    card.addEventListener('mouseleave', () => cardLeave(card));
  });

  // Reveal on scroll
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.style.opacity = '1';
        e.target.style.transform = 'none';
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('[data-reveal]').forEach(el => io.observe(el));
});
